import apiUrls from '../constants/urls'
import axios from 'axios'

export default {
  getToken (code) {
    const url = `${apiUrls.backEnd.token}?code=${code}`
    return axios.get(url)
  },

  getUser (accessToken) {
    const url = apiUrls.backEnd.user
    return axios.get(url, {
      headers: {
        Authorization: `Token ${accessToken}`
      }
    })
  }
}
